<template>
  <div class="b">
    <Nav current="公司后台"></Nav>
    <div class="titleBox">
      <el-button type="primary"
        @click="addSystem(1)"
        >新建数据源
      </el-button>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        empty-text="您还没有创建过新的数据源，请点击左上角“新建数据源”"
        :props="defaultProps"
        style="width: 100%"
        :max-height="tableHeight ? tableHeight: 0"
      >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          show-overflow-tooltip
          v-for="(col, index) in listCol"
          :key="index"
        >
          <template v-if="col.prop == 'shipping_address'"> </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <div class="link-btn border-right icon edit l" @click="addSystem(2,scope.row)">
              编辑
            </div>
            <div class="link-btn icon delete l" @click="deleteHandle(scope.row)">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新建数据源弹框 -->
    <template>
      <vxe-modal v-model="dialogFormVisible" width="850" :title="formType == 1 ? '新建数据源':'编辑数据源'">
        <div class="hncForm">
          <el-form ref="form" style="width: 730px" :model="addForm" label-width="116px" size="medium">
            <div style="display: flex;">
              <el-form-item label="系统信息">
                <el-cascader
                ref="refSubCat"
                placeholder="请选择所属系统名称/所属系统域名"
                v-model="addForm.cascaderValue"
                :options="listFkInfo"
                @change="change(addForm)"
                :props="{label :'name', value :'id'}"></el-cascader>
              </el-form-item>
              <!-- <el-form-item label="所属系统名称">
                <el-select @change="handleChange" v-model="addForm.systemId" placeholder="请选择系统名称">
                  <el-option v-for="(item,index) in listFkInfo" :key="index" :label="item.systemName" :value="item.systemId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属系统域名">
                <el-select v-model="addForm.systemDomain" placeholder="请选择系统域名">
                  <el-option v-for="(item,index) in listFkInfoChildren" :key="index" :label="item.systemDomain" :value="item.systemDomain"></el-option>
                </el-select>
              </el-form-item> -->
            </div>
            <el-form-item label="数据源名称">
              <el-input v-model="addForm.name" placeholder=" 请输入您新建数据源名称"></el-input>
            </el-form-item>
            <el-form-item label="服务器主机IP">
              <el-input v-model="addForm.host" placeholder="请输入您的服务器主机IP"></el-input>
            </el-form-item>
            <el-form-item label="服务器端口">
              <el-input type="number" v-model="addForm.port" placeholder="请输入您的服务器端口"></el-input>
            </el-form-item>
            <el-form-item label="服务器副本集">
              <el-input v-model="addForm.replicaSet" placeholder="请输入您的服务器副本集：host1:27017,host2:27017"></el-input>
            </el-form-item>
            <el-form-item label="服务器副本集名称">
              <el-input v-model="addForm.replicaName" placeholder="请输入您的服务器副本集名称："></el-input>
            </el-form-item>
            <el-form-item label="连接池大小">
              <el-input type="number" v-model="addForm.poolSize" placeholder=" 请输入连接池大小"></el-input>
            </el-form-item>
            <el-form-item label="连接超时时间">
              <el-input type="number" v-model="addForm.connectTimeout" placeholder="请输入连接超时时间"></el-input>
            </el-form-item>
            <el-form-item label="socket超时时间">
              <el-input type="number" v-model="addForm.socketTimeout" placeholder="请输入socket超时时间"></el-input>
            </el-form-item>
          </el-form>
          <div class="hncFormFoot">
            <el-button type="primary" v-if="formType == 1" @click="addFormHandle(1)">新建</el-button>
            <el-button type="primary" v-else @click="addFormHandle(2)">确定</el-button>
          </div>
        </div>
      </vxe-modal>
      <vxe-modal v-model="dialogDeleteRelationVisible" width="1000" title="温馨提示">
        <div class="hncForm hncForm1">
          <div class="title">无法删除数据源【{{currentRow ? currentRow.name : ''}}】，正在以分库的形式存放以下表单的数据</div>
          <div class="tip">
            <span class="red-txt">为保证数据准确性，请关停相关数据源的服务器后再进行以下操作： </span><br>
            1. 在「公司后台」--「数据分库」--「编辑」中将表单移动至其他数据源<br>
            2. 确认所有分库已停止使用此数据源<br>
            3. 重新尝试删除数据源
          </div>
          <el-table
            :data="tableData2"
            style="width: 100%"
            max-height="200"
          >
            <el-table-column
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minwidth"
              :width="col.width"
              :fixed="col.fixed"
              :type="col.type"
              show-overflow-tooltip
              v-for="(col, index) in listCol2"
              :key="index"
            >
              <template v-if="col.prop == 'departmentList'" scope="scope">
                {{departmentListHandle(scope.row.departmentList)}}
              </template>
              <template v-else-if="col.prop == 'dataSourceList'" scope="scope">
                {{ scope.row.dataSourceList ? scope.row.dataSourceList: 0}}
              </template>
            </el-table-column>
          </el-table>
          <div class="hncFormFoot">
            <el-button type="primary" @click="dialogDeleteRelationVisible = false">知道了</el-button>
            <!-- <el-button class="cancel" @click="dialogDeleteVisible = false">取消</el-button> -->
          </div>
        </div>
      </vxe-modal>
      <vxe-modal v-model="dialogDeleteVisible" width="850" title="删除数据源">
        <div class="hncForm">
          <div class="tip green-txt">删除{{currentRow ? currentRow.name : ''}}数据库动作不可逆，请您再次确定是否要删除</div>
          <div class="hncFormFoot">
            <el-button type="primary" @click="deleHandle">确定</el-button>
            <el-button class="cancel" @click="dialogDeleteVisible = false">取消</el-button>
          </div>
        </div>
      </vxe-modal>
    </template>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Search from "@/components/Search.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import axios from "axios";
import qs from "qs";

function T(){
  return {
    cascaderValue: [],
    "systemId":'',// "string(32) 所属系统id,从系统管理表去选择",
    "systemName": '',//"所属系统名称",
    "systemDomain":'',// "string(32) 所属系统域名"
    "host": '',//"string(32) 数据库对应的主机ip",
    "port":'',// "int  数据库对应的主机端口",
    "replicaSet": '',//"副本集",
    replicaName: '',//副本集名称
    "name":'',// "string(50)  数据源名称",
    "poolSize":'',// "int 连接池大小",
    "connectTimeout":'',// "int 连接超时,单位是毫秒,0是默认和无限,这里设置60秒",
    "socketTimeout":'',// "int 连接超时,单位是毫秒,0是默认和无限",
  }
}
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      currentRow: null,//删除行
      formType: 1,//新增1，编辑2
      listFkInfo: null,
      listFkInfoChildren: [],
      addForm: T(),
      dialogFormVisible: false,
      dialogDeleteVisible: false,
      dialogDeleteRelationVisible: false,
      ruleForm: {
        user: '',
        creator: '',
      },
      rules: {
        user: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        creator: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
      },
      searchLists: [
        {
          name: 'user',
          label: '用户',
          type: 'text',
          placeholder: '请搜索用户',
        },
        {
          name: 'creator',
          label: '创建人',
          type: 'select',
          placeholder: '请选择创建人',
          options: [
            {
              label:"区域一",
              value:1
            },
            {
              label:"区域二",
              value:2
            }
          ]
        }
      ],
      isShowDelete: false,
      disabledList:[],
      key:'',
      deleteObj: {}, //要删除的对象
      currentPage: 1,
      pageSize: 10,
      total: 10,
      name: "",
      userName: "",
      defaultProps: {
        //  列  :  显示的值
        date: "date",
        name: "name",
        address: "address",
      },
      str: "角色设置",
      tableData: [], //列表数据
      emptyText: "",
      tableHeight: "", //表格高度
      // "host": "数据库对应的主机ip",
      // "port": "数据库对应的主机端口",
      // "name": "数据源名称",
      // "poolSize": "连接池大小",
      // "connectTimeout": "连接超时,单位是毫秒",
      // "socketTimeout": "连接超时,单位是毫秒",
      // "systemId": "所属系统id",
      // "systemName": "所属系统名称",
      // "systemDomain": "所属系统域名",
      // "createTime": "创建时间"
      listCol: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          prop: "createdTime",
          label: "创建时间",
          width: "200",
          id: "id",
        },
        {
          prop: "systemName",
          label: "所属系统名称",
          minwidth: "200",
        },
        {
          prop: "systemDomain",
          label: "所属系统域名",
          minwidth: "280",
        },
        {
          prop: "name",
          label: "新数据源名称",
          minwidth: "200",
        },
        {
          prop: "host",
          label: "IP",
          minwidth: "180",
        },
        {
          prop: "port",
          label: "端口号",
          minwidth: "100",
        },
        {
          prop: "replicaSet",
          label: "副本集",
          minwidth: "180",
        },
        {
          prop: "poolSize",
          label: "连接池大小",
          minwidth: "100",
        },
        {
          prop: "connectTimeout",
          label: "连接超时时间",
          minwidth: "150",
        }
      ],
      listCol2: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          prop: "table_name",
          label: "源表单名称",
          width: "200",
          id: "id",
        },
        {
          prop: "system_name",
          label: "源系统名称",
          minwidth: "200",
        },
        {
          prop: "system_domain",
          label: "源系统域名",
          minwidth: "280",
        },
        {
          prop: "created_time",
          label: "创建时间",
          minwidth: "200",
        }
      ],
      tableData2: [],
    };
  },
  mounted() {
    this.getTableHeight()
    this.getList()
    this.getSystemInfo()
  },
  methods: {
    change(e){
      e.systemId = e.cascaderValue[0]
      e.systemDomain = e.cascaderValue[1]
    },
    handleChange(e){
      let _this = this
      let listFkInfo = this.listFkInfo
      _this.listFkInfoChildren = []
      _this.addForm.systemDomain = ''
      for (let i = 0; i < listFkInfo.length; i++) {
        const element = listFkInfo[i];
        if(element.systemId == e){
          console.log(element)
          _this.listFkInfoChildren = element.children
          return
        }
      }
    },
    //查询系统-域名-表单
    getSystemInfo(){
      let _this = this
      http.get(apiData.listFkInfo, true, {}, (res) => {
        console.log(res)
        if(res.data && res.data.data){
          _this.listFkInfo = res.data.data
        }
      });
    },
    // 新建/编辑
    addFormHandle(type){
      let _this = this
      let params = this.addForm
      if(type == 1){
        http.post(apiData.dataSourceAdd, true, params, (res) => {
          console.log(res)
          if(res.data && res.data.code && res.data.code == 200){
            this.dialogFormVisible = false
            _this.getList()
          }
        });
      }else {
        http.put(apiData.dataSourceUpdate, true, params, (res) => {
          console.log(res)
          if(res.data && res.data.code && res.data.code == 200){
            this.dialogFormVisible = false
            _this.getList()
          }
        });
      }
    },
    getTableHeight(){
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        let commonTopbar = document.querySelector('.commonTopbar').offsetHeight;
        let header = document.querySelector('.header').offsetHeight;
        this.tableHeight = parseInt(this.clientHeight - commonTopbar - header - 100);
      })
    },
    selectChangeEvent ({ $table }) {
      const records = $table.getCheckboxRecords()
      console.info(`勾选${records.length}个树形节点`, records)
    },
    visibleMethod  ({ row, type }) {
      let xTree = this.$refs.xTree
      if (type === 'body') {
        this.bodyMenus.forEach(list => {
          list.forEach(item => {
            if (['clearLoaded', 'reloadNodes'].includes(item.code)) {
              item.disabled = !row.hasChild || !xTree.isTreeExpandLoaded(row)
            } else if (['expand', 'contract'].includes(item.code)) {
              if (row.hasChild) {
                let isExpand = xTree.isTreeExpandByRow(row)
                item.disabled = ['expand'].includes(item.code) ? isExpand : !isExpand
              } else {
                item.disabled = true
              }
            }
          })
        })
      }
      return true
    },
    contextMenuClickEvent ({ menu, row, column }) {
      let xTree = this.$refs.xTree
      switch (menu.code) {
        case 'clearLoaded':
          xTree.clearTreeExpandLoaded(row)
          break
        case 'reloadNodes':
          xTree.reloadTreeExpand(row)
          break
        case 'expand':
          xTree.setTreeExpand(row, true)
          break
        case 'contract':
          xTree.setTreeExpand(row, false)
          break
      }
    },
    loadChildrenMethod ({ row }) {
      // 异步加载子节点
      return new Promise(resolve => {
        setTimeout(() => {
          const childs = [
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp4', size: null, date: '2021-10-03', hasChild: true },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-07-09', hasChild: false },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-07-09', hasChild: true },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-08-05', hasChild: false },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-07-01', hasChild: false },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-07-01', hasChild: true },
            { id: ++key, parentId: row.id, name: row.name + 'Test', type: 'mp3', size: null, date: '2021-07-01', hasChild: false }
          ]
          resolve(childs)
        }, 500)
      })
    },
    submitForm(){
      console.log('父亲',this.ruleForm)
      /* 打客服
      打客服
      但是客服
       */
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getTableHeight();
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      // console.log(val);
      this.getTableHeight();
    },
    getList(){
      let _this = this
      // 查询
      let params = {
        // "host": "数据库对应的主机ip",
        // "name": "数据源名称",
        // "systemId": "所属系统id,从系统管理表去选择"
      };

      http.get(apiData.dataSourceList, true, params, (res) => {
        if(res.data && res.data.data){
          _this.tableData = res.data.data
        }
      });
    },
    deleteHandle(row){
      console.log(row)
      this.dialogDeleteVisible = true
      this.currentRow = row
    },
    addSystem(type,row) {
      this.formType = type
      this.dialogFormVisible = true
      if(type == 1){//add
        this.addForm = T()
      }else if(type == 2){
        this.addForm = row
        row.cascaderValue = [this. addForm.systemId,this. addForm.systemDomain]
      }
    },
    //编辑
    editHandle(row) {
      this.$router.push({ name: "EditSystem", query: { id: row.id } });
    },
    deleHandle() {
      let _this = this;
      let id = _this.currentRow.id;
      console.log(id)
      http.delete(apiData.dataSourceDelete, true, { id }, (res) => {
        if (res.data.code == 200) {
          _this.dialogDeleteVisible = false
          _this.getList();
          _this.$message.success("删除成功");
        } else {
          _this.dialogDeleteVisible = false
          _this.dialogDeleteRelationVisible = true
          _this.tableData2 = res.data.data
          // _this.$message.error(res.data.msg);
        }
      });
    },
    searchRole() {
      var _this = this;
      http.get(
        apiData.systemList,
        true,
        { name: this.name, userName: this.userName },
        (res) => {
          this.tableData = res.data.data.list;
        }
      );
    },
      disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
  },

};
</script>
<style scoped lang="less">
@import './index';
//本页面
.hncForm {
  .tip {
    padding: 80px 0;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
  }
}
.titleBox {
  button {
    padding: 8px 20px;
    width: auto;
  }
}
&.hncForm1 {
  padding: 20px 20px 0 20px;
  .title {
    font-weight: bold;
    font-size: 18px;
    color: #3D3D3D;
  }
  .tip {
    padding: 10px 0 20px 0;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    .red-txt {
      color: #FF0200;
    }
  }
  .hncFormFoot {
    margin-top: 40px;
  }
}
// /deep/
// .vxe-table--render-default.border--full .vxe-body--column, .vxe-table--render-default.border--full .vxe-footer--column, .vxe-table--render-default.border--full .vxe-header--column {
//   background: none !important;
// }
// .seatch-name {
//   text-align: left;
//   display: flex;
//   input {
//     width: 120px;
//     height: 30px;
//     padding-left: 5px;
//     margin: 0 10px;
//   }
//   .el-icon-search {
//     margin-top: 0;
//     font-size: 20px;
//     display: block;
//     padding: 0 0 0 5px;
//   }
// }

</style>